import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import validateCookie from "./validateCookie";

import { LoadingWheel } from "../../styles/loading";

const Login: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {

    validateCookie()
      .then(([userData, validationResult]) => {
        if (validationResult === 0) {
          const bookingIndex = 0;
          navigate("/home", { state: { userData, bookingIndex } });
        } else {
          navigate("/selectmethod");
        }
      })
      .catch((error) => {
        console.error("Error validating cookie:", error);
        navigate("/selectmethod");
      });
  }, [navigate]);

  return (
    <LoadingWheel view="login"/>
  );
};

export default Login;
